import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { convertV3CalendarEventsToV2Appointments } from '../helpers';

type ListCalendarEventsByAttendeePageParams = {
  cursor: string;
  limit: number;
};

export const useGetCalendarEventsByAttendeeId = (
  attendeeId: string,
  locationId: string,
  childLocationsIds?: string[],
  pageParam?: ListCalendarEventsByAttendeePageParams
) => {
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const { locationTimezoneMap } = SchedulerV3.Helpers.useScheduleLocationTimezoneShallowStore('locationTimezoneMap');

  const ListCalendarEventsByAttendee = SchedulerV3.Queries.useListCalendarEventsByAttendeeQuery({
    request: {
      attendeeId,
      locationId,
      childLocationsIds,
      limit: pageParam?.limit,
      cursor: pageParam?.cursor,
      includeOperatoryDetails: true,
    },
    options: {
      enabled: isScheduleV3FlagEnabled && !!locationId && !!attendeeId,
      select: (data) => {
        return {
          ...data,
          pages: data.pages.map((page) => ({
            nextCursor: page.nextCursor,
            rows: convertV3CalendarEventsToV2Appointments(page.events, locationTimezoneMap),
          })),
        };
      },
    },
  });

  const isLoading = ListCalendarEventsByAttendee.isFetching;

  const refetch = ListCalendarEventsByAttendee.refetch;

  return { data: ListCalendarEventsByAttendee, isLoading, refetch };
};
